import type { ITimestamps } from '@pages/SensorDetails/model/timestamps';

export const getDefaultDateTime = (timestamps?: ITimestamps) => {
  let defaultDateTime = { date: '', time: '' };
  if (!timestamps) {
    return defaultDateTime;
  }

  for (const date in timestamps) {
    for (const time in timestamps[date]) {
      defaultDateTime = { date, time };
      break;
    }
    break;
  }

  return defaultDateTime;
};
